<template>
  <span
    :class="[
      'inline-flex items-center justify-center',
      sizeClasses[size],
      colorClasses[color],
      className
    ]"
  >
    <IconifyIcon :icon="name" :width="iconSize" :height="iconSize" />
  </span>
</template>

<script setup>
import { Icon as IconifyIcon } from '@iconify/vue';
import { computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value)
  },
  color: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'primary', 'secondary', 'success', 'warning', 'danger'].includes(value)
  },
  className: {
    type: String,
    default: ''
  }
});

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8'
};

const colorClasses = {
  default: 'text-gray-500',
  primary: 'text-primary-500',
  secondary: 'text-secondary',
  success: 'text-green-500',
  warning: 'text-yellow-500',
  danger: 'text-red-500'
};

const iconSize = computed(() => {
  const sizes = {
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32
  };
  return sizes[props.size];
});
</script> 